import NavSidebarHOC from "./NavSidebar/NavSidebarHOC.en";
import ShowmoreItems from "./NavSidebar/ShowmoreItems.en";

export default {
	NavSidebarHOC,
	ShowmoreItems,
};
